/* =================================================================
   VALORA theme — interactions + Shopify AJAX cart
   ================================================================= */
(function () {
  "use strict";

  var V = window.VALORA || { routes: { cart_add: "/cart/add.js", cart_change: "/cart/change.js", cart: "/cart" }, bundleMinQty: 3 };
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    var d = (cents || 0) / 100;
    var frac = d % 1 === 0 ? 0 : 2;
    return "$" + d.toLocaleString("en-US", { minimumFractionDigits: frac, maximumFractionDigits: 2 });
  }

  /* ---------- reveal ---------- */
  var revealEls = $$("[data-reveal], [data-reveal-lines]");
  if ("IntersectionObserver" in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { threshold: 0.16, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  } else { revealEls.forEach(function (el) { el.classList.add("is-in"); }); }

  /* ---------- park offscreen animation ----------
     An infinite CSS animation keeps the compositor producing frames for as
     long as the page is open, whether or not the element is anywhere near the
     viewport. The photo rails are wide composited layers, so that cost is real
     on a phone. Park them until they're on screen — the loop is seamless, so
     nobody can tell it was ever stopped. Deliberately not parked up front: if
     the observer never fires, the rails keep moving. A frozen rail is a visible
     bug; a few frames of animation before the first callback is not. */
  (function () {
    var tracks = $$(".marquee__track, .announce__track");
    if (!tracks.length || !("IntersectionObserver" in window)) return;
    var mo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) e.target.removeAttribute("data-mq-idle");
        else e.target.setAttribute("data-mq-idle", "");
      });
    }, { rootMargin: "150px 0px" });
    tracks.forEach(function (t) { mo.observe(t); });
  })();

  /* ---------- header scrolled ---------- */
  var header = $("[data-header]");
  function onScrollHeader() { if (header) header.toggleAttribute("data-scrolled", window.scrollY > 8); }
  onScrollHeader();
  window.addEventListener("scroll", onScrollHeader, { passive: true });

  /* ---------- smooth scroll (works across pages via /#id) ---------- */
  function scrollToId(id) {
    var target = document.getElementById(id);
    if (!target) return false;
    var top = target.getBoundingClientRect().top + window.scrollY - 64;
    window.scrollTo({ top: top, behavior: reduceMotion ? "auto" : "smooth" });
    return true;
  }
  $$("[data-scroll]").forEach(function (a) {
    a.addEventListener("click", function (e) {
      var href = a.getAttribute("href") || a.getAttribute("data-scroll-href") || "";
      var hashIndex = href.indexOf("#");
      if (hashIndex === -1) return;
      var id = href.slice(hashIndex + 1);
      if (document.getElementById(id)) { e.preventDefault(); scrollToId(id); closeMobileNav(); }
      // else: let the browser navigate (e.g. /#science from another page)
    });
  });
  var heroScroll = $(".hero__scroll");
  if (heroScroll) heroScroll.addEventListener("click", function () { scrollToId((heroScroll.getAttribute("data-scroll-href") || "").replace("#", "")); });

  /* ---------- mobile nav ---------- */
  var navToggle = $("[data-nav-toggle]"), mobileNav = $("[data-mobile-nav]");
  function closeMobileNav() { if (mobileNav) { mobileNav.hidden = true; if (navToggle) navToggle.setAttribute("aria-expanded", "false"); } }
  if (navToggle && mobileNav) {
    navToggle.addEventListener("click", function () {
      var open = navToggle.getAttribute("aria-expanded") === "true";
      navToggle.setAttribute("aria-expanded", String(!open));
      mobileNav.hidden = open;
    });
  }

  /* ---------- hero aura ---------- */
  var auraScope = $("[data-aura-scope]"), aura = $("[data-aura]");
  if (auraScope && aura && !reduceMotion) {
    auraScope.addEventListener("pointermove", function (e) {
      var r = auraScope.getBoundingClientRect();
      aura.style.setProperty("--mx", ((e.clientX - r.left) / r.width * 100) + "%");
      aura.style.setProperty("--my", ((e.clientY - r.top) / r.height * 100) + "%");
    });
  }

  /* ---------- parallax ---------- */
  var parallaxEls = $$("[data-parallax]");
  if (parallaxEls.length && !reduceMotion) {
    var ticking = false;
    function runParallax() {
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var depth = parseFloat(el.getAttribute("data-depth")) || 0.18;
        var offset = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = "translate3d(0," + (offset * depth * -60).toFixed(2) + "px,0)";
      });
      ticking = false;
    }
    window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(runParallax); } }, { passive: true });
    runParallax();
  }

  /* ---------- NAD+ lifeline ---------- */
  (function () {
    var fig = $("[data-lifeline]");
    if (!fig) return;
    /* The chart is drawn 1:1 with its rendered pixel box and the viewBox is
       re-synced on resize. Letting the browser stretch a fixed 800x380 viewBox
       (preserveAspectRatio="none") squashed the curve differently at every
       window width, and because the stroke is non-scaling it also made
       getTotalLength() (user units) disagree with the on-screen length — so on
       wide screens the reveal dash left a gap and the tail of the curve simply
       never appeared. W/H below are only the pre-layout fallback. */
    var W = 800, H = 380, PAD_T = 24, PAD_B = 44, PAD_X = 10, AGE_MIN = 30, AGE_MAX = 65;
    var svg = $(".lifeline__svg", fig);
    var curve = $("[data-ll-curve]", fig), area = $("[data-ll-area]", fig), grid = $("[data-ll-grid]", fig);
    var guide = $("[data-ll-guide]", fig), dot = $("[data-ll-dot]", fig), range = $("[data-ll-range]", fig);
    var ageOut = $("[data-ll-age]", fig), nadOut = $("[data-ll-nad]", fig), capOut = $("[data-ll-caption]", fig), plot = $(".lifeline__plot", fig);

    function nadAt(age) { var t = (age - AGE_MIN) / (AGE_MAX - AGE_MIN); return 90 - 55 * Math.pow(t, 1.4); }
    function ageToX(age) { return PAD_X + (age - AGE_MIN) / (AGE_MAX - AGE_MIN) * (W - PAD_X * 2); }
    function nadToY(v) { return PAD_T + (90 - v) / (90 - 35) * (H - PAD_T - PAD_B); }
    function buildPath(close) {
      var pts = [], age;
      for (age = AGE_MIN; age <= AGE_MAX; age++) pts.push([ageToX(age), nadToY(nadAt(age))]);
      var d = "M" + pts[0][0] + "," + pts[0][1];
      for (var i = 0; i < pts.length - 1; i++) {
        var x0 = pts[i][0], y0 = pts[i][1], x1 = pts[i + 1][0], y1 = pts[i + 1][1];
        d += " Q" + x0 + "," + y0 + " " + ((x0 + x1) / 2) + "," + ((y0 + y1) / 2);
      }
      d += " L" + pts[pts.length - 1][0] + "," + pts[pts.length - 1][1];
      if (close) d += " L" + pts[pts.length - 1][0] + "," + (H - PAD_B) + " L" + pts[0][0] + "," + (H - PAD_B) + " Z";
      return d;
    }
    function drawGrid() {
      grid.textContent = "";
      [90, 75, 60, 45, 35].forEach(function (v) {
        var y = nadToY(v), ln = document.createElementNS("http://www.w3.org/2000/svg", "line");
        ln.setAttribute("x1", PAD_X); ln.setAttribute("x2", W - PAD_X); ln.setAttribute("y1", y); ln.setAttribute("y2", y);
        grid.appendChild(ln);
      });
    }
    function layout() {
      var r = svg.getBoundingClientRect();
      if (!r.width || !r.height) return;
      W = Math.round(r.width); H = Math.round(r.height);
      svg.setAttribute("viewBox", "0 0 " + W + " " + H);
      curve.setAttribute("d", buildPath(false));
      area.setAttribute("d", buildPath(true));
      drawGrid();
      render(+range.value);
    }
    function clearDash() {
      curve.style.strokeDasharray = "none"; curve.style.strokeDashoffset = "0"; curve.style.transition = "";
    }
    function captionFor(age) {
      if (age <= 41) return "Early perimenopause can begin here. NAD⁺ in key tissues is already trending down.";
      if (age <= 50) return "The decline tends to steepen. This is the window where “I don’t feel like myself” shows up most.";
      if (age <= 58) return "Into menopause. Supporting healthy NAD⁺ levels matters most through this stretch.";
      return "Post-menopause. Consistency is everything — a molecule you keep topped up, daily.";
    }
    function render(age) {
      age = Math.round(age);
      var v = nadAt(age), x = ageToX(age), y = nadToY(v);
      dot.style.left = (x / W * 100) + "%"; dot.style.top = (y / H * 100) + "%";
      guide.setAttribute("x1", x); guide.setAttribute("x2", x); guide.setAttribute("y1", y); guide.setAttribute("y2", H - PAD_B);
      ageOut.textContent = age; nadOut.textContent = "~" + Math.round(v); capOut.textContent = captionFor(age);
    }
    range.addEventListener("input", function () { render(+range.value); });
    function setFromX(clientX) {
      var r = plot.getBoundingClientRect(), ratio = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
      range.value = Math.round(AGE_MIN + ratio * (AGE_MAX - AGE_MIN)); render(+range.value);
    }
    var dragging = false;
    plot.addEventListener("pointerdown", function (e) { dragging = true; setFromX(e.clientX); });
    window.addEventListener("pointermove", function (e) { if (dragging) setFromX(e.clientX); });
    window.addEventListener("pointerup", function () { dragging = false; });
    function draw() {
      layout();
      if (!reduceMotion) { try { var len = curve.getTotalLength(); curve.style.strokeDasharray = len; curve.style.strokeDashoffset = len; curve.getBoundingClientRect(); curve.style.transition = "stroke-dashoffset 1.5s cubic-bezier(.16,1,.3,1)"; curve.style.strokeDashoffset = "0"; setTimeout(clearDash, 1700); } catch (e) { clearDash(); } }
      render(+range.value);
    }
    /* re-fit to the new box; the dash is dropped first so a resize mid-reveal
       can never leave the curve broken */
    var resizeT;
    window.addEventListener("resize", function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () { clearDash(); layout(); }, 120);
    });
    layout();
    if ("IntersectionObserver" in window) {
      var io2 = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { draw(); io2.unobserve(e.target); } }); }, { threshold: 0.3 });
      io2.observe(fig);
    } else { draw(); }
  })();

  /* ---------- count-up ---------- */
  (function () {
    var stats = $$("[data-count]");
    if (!stats.length) return;
    function up(el) {
      var target = parseFloat(el.getAttribute("data-count")), suffix = el.getAttribute("data-suffix") || "";
      var dec = (String(target).split(".")[1] || "").length;
      if (reduceMotion) { el.textContent = target.toFixed(dec) + suffix; return; }
      var start = performance.now();
      (function step(now) {
        var p = Math.min(1, (now - start) / 1400), e = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * e).toFixed(dec) + suffix;
        if (p < 1) requestAnimationFrame(step); else el.textContent = target.toFixed(dec) + suffix;
      })(start);
    }
    if ("IntersectionObserver" in window) {
      var io3 = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { up(e.target); io3.unobserve(e.target); } }); }, { threshold: 0.6 });
      stats.forEach(function (el) { io3.observe(el); });
    } else { stats.forEach(up); }
  })();

  /* ---------- FAQ accordion ---------- */
  $$(".faq-item__body").forEach(function (b) { b.style.transition = "height .35s cubic-bezier(.22,.61,.36,1)"; });
  $$(".faq-item").forEach(function (item) {
    var summary = $("summary", item), body = $(".faq-item__body", item);
    summary.addEventListener("click", function (e) {
      e.preventDefault();
      if (item.open) {
        body.style.height = body.scrollHeight + "px";
        requestAnimationFrame(function () { body.style.height = "0px"; });
        body.addEventListener("transitionend", function te() { item.open = false; body.style.height = ""; body.removeEventListener("transitionend", te); });
      } else {
        item.open = true; var h = body.scrollHeight; body.style.height = "0px";
        requestAnimationFrame(function () { body.style.height = h + "px"; });
        body.addEventListener("transitionend", function te() { body.style.height = ""; body.removeEventListener("transitionend", te); });
      }
    });
  });

  /* =================================================================
     SHOPIFY AJAX CART
     ================================================================= */
  var cart = $("[data-cart]"), itemsEl = $("[data-cart-items]"), giftsEl = $("[data-cart-gifts]");
  var upsellEl = $("[data-cart-upsell]"), countEl = $("[data-cart-count]"), headingEl = $("[data-cart-heading]");
  var totalEl = $("[data-cart-total]"), saveEl = $("[data-cart-save]"), toast = $("[data-toast]");
  var progEl = $("[data-cart-progress]"), progFill = $("[data-cart-progress-fill]"), progMsg = $("[data-cart-progress-msg]");

  var BUNDLE_QTY = (V && V.bundleMinQty) || 3;
  var GIFTS = (V && V.gifts) || [{ name: "$30 store gift card", was: 3000, icon: "card" }, { name: "Longevity Reset Guide (PDF)", was: 1900, icon: "book" }];
  var OFFERS = (V && V.offers) || {
    b2g1: { name: "Buy 2, Get 1 Free", price: 11800, image: "" },
    system: { name: "Inside-Out Longevity System", price: 14900, image: "" }
  };
  var ROUTES = (V && V.routes) || { add: "/cart/add.js", change: "/cart/change.js", update: "/cart/update.js", cart: "/cart.js" };
  var currentCart = { item_count: 0, items: [] };

  // Both multi-bottle offers are 3 units of the REAL NMN variant, so fulfilment always sees
  // 3 × the NMN SKU. What separates them is whether the two gift lines are in the cart:
  //
  //   3 NMN alone          → "Buy 2, Get 1 Free — NMN" (native Buy X Get Y) makes one free → $118
  //   3 NMN + both gifts   → gifts BXGY zeroes them + $28 off the order          → $149
  //
  // The gift lines ARE the offer state: it lives in the cart, survives reloads, and is the one
  // thing Shopify's discount engine can actually see (it cannot read line-item properties).
  // "Buy 2, Get 1 Free — NMN" is capped at one free bottle and refuses to combine with order
  // discounts, so on a gifted cart the gifts + $28 ($101.90) always beat it ($59) and Shopify
  // picks the System pricing; on a giftless cart it wins and blocks the $28.
  //
  // Gummies & serum are ALSO sold on their own, so a gift line is told apart from a paid one by a
  // hidden `_gift` line-item property — NOT by variant id (same variant, different line).
  var nmnId = (V && V.nmnVariantId) || 0;
  var nmnUnit = (V && V.nmnUnitPrice) || 5900;
  var giftIds = (V && V.giftVariantIds) || [];
  function isGift(it) { return !!(it.properties && (it.properties._gift === "1")); }
  function isNmn(it) { return it.variant_id === nmnId || it.id === nmnId; }
  function lineOf(c, vid) { return (c.items || []).filter(function (it) { return it.variant_id === vid || it.id === vid; })[0]; }
  function giftLineOf(c, vid) { return (c.items || []).filter(function (it) { return (it.variant_id === vid || it.id === vid) && isGift(it); })[0]; }
  function mainItemsOf(c) { return (c.items || []).filter(function (it) { return !isGift(it); }); }
  function mainQtyOf(c) { return mainItemsOf(c).reduce(function (s, it) { return s + it.quantity; }, 0); }
  function nmnQtyOf(c) { return (c.items || []).filter(function (it) { return isNmn(it) && !isGift(it); }).reduce(function (s, it) { return s + it.quantity; }, 0); }
  function hasGifts(c) { return (c.items || []).some(isGift); }

  function fmt(c) { return "$" + ((c || 0) / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function giftIcon(t) {
    if (t === "ship") return '<svg viewBox="0 0 24 24" fill="none"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><circle cx="7" cy="17" r="1.8" stroke="currentColor" stroke-width="1.4"/><circle cx="17" cy="17" r="1.8" stroke="currentColor" stroke-width="1.4"/></svg>';
    return '<svg viewBox="0 0 24 24" fill="none"><rect x="3" y="7" width="18" height="13" rx="2" stroke="currentColor" stroke-width="1.4"/><path d="M3 11h18M8 7c-1.5-3 3-4 4-1 1-3 5.5-2 4 1" stroke="currentColor" stroke-width="1.4"/></svg>';
  }
  function thumb(url) { return url ? url.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : ""; }
  function supplyLabel(q, nmn, gifted) {
    if (nmn && q >= BUNDLE_QTY) return gifted ? "Longevity System · " + q + " bottles" : "Buy 2, Get 1 Free · " + q + " bottles";
    return q === 1 ? "Single bottle" : q + "-bottle supply";
  }

  // The $28 bundle saving is an ORDER-scope automatic discount, so Shopify never
  // folds it into the NMN line price — it only lands on the cart total. Pull it out
  // so the line can show "$149.00  $177.00" the same way the gift rows do.
  function orderLevelDiscount(c) {
    var apps = c.cart_level_discount_applications || [];
    if (apps.length) {
      return apps.reduce(function (a, d) { return a + (d.total_allocated_amount || 0); }, 0);
    }
    var lineDisc = (c.items || []).reduce(function (a, it) {
      return a + ((it.original_line_price || 0) - (it.final_line_price || 0));
    }, 0);
    return Math.max(0, (c.total_discount || 0) - lineDisc);
  }

  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg; toast.hidden = false;
    requestAnimationFrame(function () { toast.setAttribute("data-show", ""); });
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.removeAttribute("data-show"); setTimeout(function () { toast.hidden = true; }, 320); }, 2400);
  }
  function openCart() { if (cart) { cart.hidden = false; requestAnimationFrame(function () { cart.setAttribute("data-open", ""); }); } }
  function closeCart() { if (cart) { cart.removeAttribute("data-open"); setTimeout(function () { cart.hidden = true; }, 400); } }

  function render(c) {
    currentCart = c;
    var mainItems = mainItemsOf(c);            // paid lines only (gift lines shown separately as perks)
    var nmnQty = nmnQtyOf(c);                  // paid NMN drives both bundle offers
    var earned = nmnQty >= BUNDLE_QTY;
    var gifted = hasGifts(c);                  // gifts in the cart = the Longevity System
    var b2g1 = earned && !gifted;              // 3 bottles, no gifts = Buy 2, Get 1 Free
    var count = mainQtyOf(c);

    if (headingEl) headingEl.textContent = "Cart (" + count + ")";
    if (countEl) { countEl.textContent = count; countEl.hidden = count === 0; }
    if (totalEl) {
      // original_total_price = every item at full price, i.e. buying them separately
      var origTotal = c.original_total_price || c.total_price;
      totalEl.innerHTML = origTotal > c.total_price
        ? '<s>' + fmt(origTotal) + '</s> ' + fmt(c.total_price)
        : fmt(c.total_price);
    }

    if (progEl) {
      progEl.hidden = nmnQty === 0;
      if (progFill) progFill.style.width = (Math.min(nmnQty / BUNDLE_QTY, 1) * 100) + "%";
      // one more click always reaches the offer now — 2 is stepped over, not stopped on
      if (progMsg) progMsg.textContent = gifted
        ? "You've unlocked free shipping + 2 free gifts"
        : b2g1
          ? "Free 3rd bottle + free shipping unlocked"
          : "Add 1 more — your 3rd bottle comes free, and so does shipping";
    }

    if (itemsEl) {
      var orderDisc = orderLevelDiscount(c);
      // Buy 2 Get 1 Free splits the bottles across two lines (2 charged + 1 at $0), which would
      // otherwise show up as two NMN rows the shopper has to reason about. Collapse every NMN
      // line into a single row carrying the combined quantity and price; its +/- set the total.
      var nmnLines = mainItems.filter(isNmn);
      var rows = mainItems.filter(function (it) { return !isNmn(it); }).map(function (it) {
        return { nmn: false, key: it.key, title: it.product_title, image: it.image, qty: it.quantity,
                 now: it.final_line_price, was: it.original_line_price };
      });
      if (nmnLines.length) {
        rows.unshift({
          nmn: true, key: nmnLines[0].key, title: nmnLines[0].product_title, image: nmnLines[0].image, qty: nmnQty,
          now: nmnLines.reduce(function (s, it) { return s + it.final_line_price; }, 0),
          was: nmnLines.reduce(function (s, it) { return s + it.original_line_price; }, 0)
        });
      }
      // the cart-scope saving ($28) belongs to the bottles when there are any
      rows.forEach(function (r, i) { if (nmnQty > 0 ? r.nmn : i === 0) r.now -= orderDisc; });

      if (!count) itemsEl.innerHTML = '<p class="cart__empty">Your cart is empty.</p>';
      else itemsEl.innerHTML = rows.map(function (r) {
        var img = r.image ? '<img src="' + thumb(r.image) + '" alt="" loading="lazy">' : "";
        return '<div class="cart-line" data-key="' + r.key + '"' + (r.nmn ? ' data-nmn' : '') + '>' +
          '<div class="cart-line__media">' + img + '</div>' +
          '<div class="cart-line__main">' +
            '<div class="cart-line__top"><span class="cart-line__name">' + r.title + '</span>' +
            '<span class="cart-line__price">' + fmt(r.now) + (r.was > r.now ? ' <s>' + fmt(r.was) + '</s>' : '') + '</span></div>' +
            '<div class="cart-line__supply">' + supplyLabel(r.qty, r.nmn, gifted) + '</div>' +
            '<div class="cart-line__onetime">One-time purchase · ships once</div>' +
            '<div class="cart-line__controls"><div class="cart-qty">' +
              '<button type="button" data-dec aria-label="Decrease">−</button><span class="mono">' + r.qty + '</span><button type="button" data-inc aria-label="Increase">+</button>' +
            '</div><button type="button" class="cart-line__remove" data-remove>Remove</button></div>' +
          '</div></div>';
      }).join("");
    }

    if (giftsEl) {
      giftsEl.hidden = !(gifted || b2g1);
      var giftRow = function (g) {
        var media = g.image ? '<img src="' + g.image + '" alt="">' : giftIcon(g.icon);
        var price = g.was > 0 ? '$0.00 <s>' + fmt(g.was) + '</s>' : 'Free';
        return '<div class="cart-gift"><div class="cart-gift__media">' + media + '</div>' +
          '<div class="cart-gift__main"><div class="cart-gift__top"><span class="cart-gift__name">' + g.name + '</span>' +
          '<span class="cart-gift__price">' + price + '</span></div>' +
          '<div class="cart-gift__label">Free gift</div><div class="cart-gift__note">' + g.note + '</div></div></div>';
      };
      giftsEl.innerHTML = gifted
        ? '<p class="cart-gifts__title">Your Longevity System — free with your bottles</p>' +
          '<p class="cart-gifts__sub">NMN resets you from the inside. Your gummies and serum work on hair, skin and nails from the outside.</p>' +
          GIFTS.map(giftRow).join("")
        : b2g1
          ? '<p class="cart-gifts__title">Buy 2, Get 1 Free — unlocked</p>' +
            '<p class="cart-gifts__sub">Three bottles ship. You pay for two — the third comes off at checkout.</p>' +
            [{ name: "3rd Bottle of NMN", note: "30 more servings — on us", was: nmnUnit, icon: "gift" },
             { name: "Free shipping", note: "Ships free in 1–2 days", was: 0, icon: "ship" }].map(giftRow).join("")
          : "";
    }

    // One upgrade per cart state, each pointing at the next step up: loose bottles → the
    // bundle everyone should be on, the bundle → the System (the only card that sells hard),
    // the System → a quiet way back down. Never more than one ask on screen.
    if (upsellEl) {
      var quiet = gifted;
      var kind = gifted ? "b2g1" : b2g1 ? "system" : count > 0 ? "b2g1" : null;
      var media = function (o) { return '<div class="upsell-card__media">' + (o.image ? '<img src="' + o.image + '" alt="" loading="lazy">' : '') + '</div>'; };
      var addBtn = function (k, label) { return '<button type="button" class="upsell-card__add" data-upsell="' + k + '" aria-label="' + label + '">+</button>'; };

      upsellEl.hidden = !kind;
      upsellEl.classList.toggle("cart__upsell--quiet", !!quiet);

      if (!kind) {
        upsellEl.innerHTML = "";
      } else if (quiet) {
        // switching down is offered, never recommended — a plain line, no card, no photo
        upsellEl.innerHTML =
          '<button type="button" class="cart__swap" data-upsell="b2g1">' +
            'Don’t need the gifts? <span>Switch to Buy 2, Get 1 Free — ' + money(OFFERS.b2g1.price) + '</span>' +
          '</button>';
      } else if (kind === "system") {
        var extra = OFFERS.system.price - OFFERS.b2g1.price;
        var paidGifts = GIFTS.filter(function (g) { return g.was > 0; });
        var giftValue = paidGifts.reduce(function (s, g) { return s + g.was; }, 0);
        upsellEl.innerHTML =
          '<p class="cart__upsell-title">Complete your routine</p>' +
          '<div class="upsell-card">' + media(OFFERS.system) +
            '<div><div class="upsell-card__name">' + OFFERS.system.name + '</div>' +
            '<div class="upsell-card__price"><b>+' + money(extra) + '</b> · same 3 bottles, plus both gifts</div></div>' +
            addBtn("system", "Upgrade to the Inside-Out Longevity System") +
          '</div>' +
          '<div class="upsell-gifts">' + paidGifts.map(function (g) {
            return '<span class="upsell-gift">' + (g.image ? '<img src="' + g.image + '" alt="" loading="lazy">' : '') +
              '<span class="upsell-gift__t">' + g.name + '<s>' + money(g.was) + '</s></span></span>';
          }).join("") + '</div>' +
          '<p class="upsell-foot">' + money(giftValue) + ' of gifts, yours free — ' + money(OFFERS.system.price) + ' total</p>';
      } else {
        upsellEl.innerHTML =
          '<p class="cart__upsell-title">Best value</p>' +
          '<div class="upsell-card">' + media(OFFERS.b2g1) +
            '<div><div class="upsell-card__name">' + OFFERS.b2g1.name + '</div>' +
            '<div class="upsell-card__price">3 bottles for the price of 2 · <b>' + money(OFFERS.b2g1.price) + '</b></div></div>' +
            addBtn("b2g1", "Switch to Buy 2, Get 1 Free") +
          '</div>';
      }
    }

    if (saveEl) {
      var saved = (c.original_total_price || 0) - (c.total_price || 0);
      saveEl.hidden = saved <= 0;
      saveEl.textContent = "You’re saving " + money(saved);
    }
  }

  function getCart() { return fetch(ROUTES.cart, { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }
  function postJSON(url, body) { return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) }).then(function (r) { return r.json(); }); }

  // The gift lines are added/removed by the offer the shopper picks, not by quantity alone —
  // 3 bottles means Buy 2 Get 1 Free without them and the Longevity System with them. The only
  // rule enforced on every refresh is that gifts can't outlive the bottles that earned them.
  function giftsEarned(c) { return nmnQtyOf(c) >= BUNDLE_QTY; }
  function addGifts(c) {
    if (!giftIds.length) return Promise.resolve(c);
    var toAdd = giftIds.filter(function (gid) { return !giftLineOf(c, Number(gid)); })
                       .map(function (gid) { return { id: Number(gid), quantity: 1, properties: { _gift: "1" } }; });
    if (!toAdd.length) return Promise.resolve(c);
    return postJSON(ROUTES.add, { items: toAdd }).then(getCart);
  }
  // Both gift lines go in ONE /cart/update.js call. Removing them one key at a time does not
  // work: the first removal re-keys the surviving lines, so the second request comes back
  // `400 no valid id or line parameter` and that gift stays in the cart, quietly charged for.
  function removeGifts(c) {
    var items = c.items || [];
    if (!items.some(isGift)) return Promise.resolve(c);
    return postJSON(ROUTES.update, { updates: items.map(function (it) { return isGift(it) ? 0 : it.quantity; }) }).then(getCart);
  }
  // Gifts are all-or-nothing: the $28 order discount keys off a 5-item cart (3 bottles + both
  // gifts), so a cart holding only one gift would silently lose it. Top the pair back up.
  function syncGifts(c) {
    if (!giftsEarned(c)) return removeGifts(c);
    return hasGifts(c) ? addGifts(c) : Promise.resolve(c);
  }

  // Two bottles is never worth resting on: Buy 2 Get 1 Free means 3 bottles cost the same $118
  // as 2, so a 2-bottle cart is pure loss for the shopper. The +/- skip straight over it, and
  // this catches the ways round them (removing the free line from /cart, carts predating this).
  // Topping up is always safe — it's the same money for one more bottle.
  function syncSkipTwo(c) {
    if (nmnQtyOf(c) !== 2) return Promise.resolve(c);
    return postJSON(ROUTES.add, { items: [{ id: nmnId, quantity: BUNDLE_QTY - 2 }] }).then(getCart);
  }

  // Shopify briefly locks the cart between rapid mutations, and a locked /cart/change
  // resolves with an error body rather than throwing — so a sync pass can silently do
  // half its work (seen live: dropping 3 bottles → 2 removed one gift but left the other,
  // quietly charging for it). Never trust one pass: verify the cart actually matches the
  // offer rules and re-run the sync (bounded) until it does.
  function cartInSync(c) {
    if (nmnQtyOf(c) === 2) return false;
    if (!giftsEarned(c)) return !hasGifts(c);
    return !hasGifts(c) || !giftIds.some(function (gid) { return !giftLineOf(c, Number(gid)); });
  }
  function syncCart(c, attempt) {
    return syncSkipTwo(c).then(syncGifts).then(function (c2) {
      if (attempt >= 2 || cartInSync(c2)) return c2;
      return syncCart(c2, attempt + 1);
    });
  }
  function refresh() { return getCart().then(function (c) { return syncCart(c, 0); }).then(render); }

  function addToCart(variantId, qty) { return postJSON(ROUTES.add, { items: [{ id: Number(variantId), quantity: qty }] }).then(refresh); }
  function changeQty(key, qty) { return postJSON(ROUTES.change, { id: key, quantity: qty }).then(refresh); }
  // Bottles can sit on two lines once Buy 2 Get 1 Free splits the free one off, so the row's +/-
  // set a TOTAL. Growing is a plain add; shrinking goes through /cart/update.js's positional array
  // so every line moves in one atomic request — changing them one key at a time lets Shopify
  // re-split the offer underneath us and the later keys quietly miss. (An `updates` object keyed
  // by variant id does NOT work here: with the variant on two lines it re-adds instead of setting.)
  function setNmnQty(qty) {
    return getCart().then(function (c) {
      var items = c.items || [];
      var cur = nmnQtyOf(c), target = Math.max(0, qty);
      // Step over 2 rather than landing on it: going up lands on the offer (3 bottles for the
      // same $118), coming down clears past it to a single bottle.
      if (target === 2) target = target > cur ? BUNDLE_QTY : 1;
      if (target === cur) return c;
      if (target > cur) return postJSON(ROUTES.add, { items: [{ id: nmnId, quantity: target - cur }] }).then(getCart);
      var surplus = cur - target;
      var updates = items.map(function (it) {
        if (!isNmn(it) || isGift(it) || surplus <= 0) return it.quantity;
        var take = Math.min(surplus, it.quantity);
        surplus -= take;
        return it.quantity - take;
      });
      return postJSON(ROUTES.update, { updates: updates }).then(getCart);
    }).then(refresh);
  }

  // Picking a bundle tile tops the cart up to `qty` real NMN bottles and then sets the gift
  // lines to match the offer — the gifts are what tell the two 3-bottle offers apart, both in
  // this drawer and to Shopify's discount engine.
  function applyNmnOffer(qty, offer) {
    return getCart().then(function (c) {
      var cur = nmnQtyOf(c);
      if (cur >= qty) return c;
      return postJSON(ROUTES.add, { items: [{ id: nmnId, quantity: qty - cur }] }).then(getCart);
    }).then(function (c) {
      return offer === "system" ? addGifts(c) : removeGifts(c);
    }).then(refresh);
  }

  // Adding loose bottles goes through setNmnQty so the single-bottle tile steps 1 → 3 as well,
  // rather than parking the shopper on a 2-bottle cart that costs the same as three.
  function addNmnBottles(n) {
    return getCart().then(function (c) { return setNmnQty(nmnQtyOf(c) + n); });
  }

  // Shared with valora-pdp.js so the express-wallet buttons check out through this same path —
  // every branch ends in refresh(), so the promise doesn't resolve until the cart is settled.
  (window.VALORA = window.VALORA || {}).cart = {
    addOffer: function (variantId, qty, offer) {
      qty = parseInt(qty || "1", 10);
      // Only the NMN bundle tiles touch the gift lines; everything else — including a
      // gummies/serum 3-pack — is a plain add.
      if (Number(variantId) !== nmnId) return addToCart(variantId, qty);
      return (offer === "system" || offer === "b2g1") ? applyNmnOffer(qty, offer) : addNmnBottles(qty);
    }
  };

  $$("[data-add-to-cart]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var id = btn.getAttribute("data-variant-id"), qty = parseInt(btn.getAttribute("data-qty") || "1", 10);
      if (!id || id === "0") { showToast("Connect your product in Theme editor → Offer"); return; }
      var offer = btn.getAttribute("data-offer") || "";
      var isNmnBtn = Number(id) === nmnId;
      var bundled = isNmnBtn && (offer === "system" || offer === "b2g1");
      var before = nmnQtyOf(currentCart);
      btn.disabled = true; btn.style.opacity = ".7";
      var op = bundled ? applyNmnOffer(qty, offer) : isNmnBtn ? addNmnBottles(qty) : addToCart(id, qty);
      op.then(function () {
        btn.disabled = false; btn.style.opacity = "";
        // a loose bottle that stepped over 2 lands on the offer — say so, or the jump to
        // 3 bottles reads as a bug rather than a free one
        var jumped = isNmnBtn && !bundled && before < BUNDLE_QTY && nmnQtyOf(currentCart) >= BUNDLE_QTY;
        showToast(offer === "system" ? "Added — Inside-Out Longevity System"
          : offer === "b2g1" || jumped ? "Buy 2, Get 1 Free — your 3rd bottle is free"
          : "Added to cart");
        openCart();
      }).catch(function () { btn.disabled = false; btn.style.opacity = ""; showToast("Something went wrong — try again"); });
    });
  });

  if (itemsEl) itemsEl.addEventListener("click", function (e) {
    var line = e.target.closest(".cart-line"); if (!line) return;
    var key = line.getAttribute("data-key");
    var span = $(".cart-qty span", line), qty = parseInt(span ? span.textContent : "1", 10);
    var set = line.hasAttribute("data-nmn") ? setNmnQty : function (q) { return changeQty(key, q); };
    if (e.target.closest("[data-inc]")) set(qty + 1);
    else if (e.target.closest("[data-dec]")) set(Math.max(0, qty - 1));
    else if (e.target.closest("[data-remove]")) set(0);
  });

  if (upsellEl) upsellEl.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-upsell]");
    if (!btn || !nmnId) return;
    var kind = btn.getAttribute("data-upsell") === "b2g1" ? "b2g1" : "system";
    btn.disabled = true;
    applyNmnOffer(BUNDLE_QTY, kind).then(function () {
      showToast(kind === "system" ? "Upgraded — 2 free gifts added" : "Switched — Buy 2, Get 1 Free");
    }).catch(function () { btn.disabled = false; showToast("Something went wrong — try again"); });
  });

  $$("[data-cart-open]").forEach(function (b) { b.addEventListener("click", function () { refresh(); openCart(); }); });
  $$("[data-cart-close]").forEach(function (b) { b.addEventListener("click", closeCart); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });
  var checkout = $("[data-checkout]");
  if (checkout) checkout.addEventListener("click", function () { if ((currentCart.item_count || 0) === 0) { showToast("Your cart is empty"); return; } window.location.href = "/checkout"; });

  refresh();
})();
